// extracted by mini-css-extract-plugin
export var header = "_gu-0";